import { ERROR, FLUSH, MESSAGE, POST_DETAILS, POST_LIST, POST_COMMENTS, POST_LIKES } from './constants';
import { SERVER_ADDR } from '../../../constants';
import { resetMessage } from '../common/action';

export const addPost = (formData) => async (dispatch, getState, api) => {
  try {

    if (formData.postImages && formData.postImages.length > 0) {
      const images = [];
      formData.postImages.forEach(f => {
        images.push(f.name);
      });

      formData.images = images;
      delete formData.postImages;
    }

    if (formData.age_range) {
      const age = formData.age_range.split('-');
      const minAge = age[0];
      const maxAge = age[1] || 100;
      formData.min_age = parseInt(minAge);
      formData.max_age = parseInt(maxAge);

      delete formData.age_range;
    }
  
    console.log('formData', formData);
    const res = await api
      .post(`${SERVER_ADDR}post`, { data: formData });
    
    if (res.code === 200) {
      dispatch({
        type: MESSAGE,
        message: 'Post Succesfully Added'
      });

      dispatch(resetMessage(MESSAGE));
      return;
    }

    throw new Error('Something went wrong');
  } catch (e) {
    console.log(e);
    throw new Error(e);
  }
}

export const getPostList = (page, offset) => async (dispatch, getState, api) => {
  try {
    const res = await api
      .get(`${SERVER_ADDR}post?page=${page}&offset=${offset}`);

      if (res.code === 200) {
        dispatch({
          type: POST_LIST,
          result: res.body
        });

        return;
      }

      throw new Error('Something went wrong');
  } catch (e) {
    console.log(e);
    // throw new Error(e);
  }
}

export const getRoomerPostList = (page, offset) => async (dispatch, getState, api) => {
  try {
    const res = await api
      .get(`${SERVER_ADDR}roomer-post?page=${page}&offset=${offset}`);

      if (res.code === 200) {
        dispatch({
          type: POST_LIST,
          result: res.body
        });

        return;
      }
  } catch (e) {
    console.log(e);
  }
}

export const getPostDetail = (postId) => async (dispatch, getState, api) => {
  try {
    const res = await api
      .get(`${SERVER_ADDR}post/${postId}`);
    
    if (res.body) {
      if (res.body.postImages.length) {
        res.body.images = res.body.postImages;
      }

      delete res.body.postImages;

      dispatch({
        type: POST_DETAILS,
        result: res.body
      });

      return res.body;
    }
  } catch (e) {
    console.log(e);
  }
}

export const deletePostImage = (imageId) => async (dispatch, getState, api) => {
  try {
    const getDetails = getState().post.details;
    const newDetails = getDetails.images.filter(g => g.id !== imageId);
    const res = await api.del(`${SERVER_ADDR}post/image/${imageId}`);

    if (res.body) {
      const obj = Object.assign({}, getDetails, {
        images: newDetails
      });

      dispatch({
        type: POST_DETAILS,
        result: obj
      });
    }
  } catch (e) {
    console.log(e);
  }
}

export const editPost = (formData, postId) => async (dispatch, getState, api) => {
  try {
    if (formData.postImages && formData.postImages.length > 0) {
      const images = [];
      formData.postImages.forEach(f => {
        images.push(f.name);
      });

      formData.images = images;
      delete formData.postImages;
    }

    const res = await api
      .put(`${SERVER_ADDR}post/${postId}`, { data: formData });

    dispatch(getPostDetail(postId));

    dispatch({
      type: MESSAGE,
      message: 'Post Updated'
    });

    dispatch(resetMessage(MESSAGE));
  } catch (e) {
    console.log(e);
  }
}

export const deletePost = (postId) => async (dispatch, getState, api) => {
  try {
    const postList = getState().post.list.rows.filter(p => p.id !== postId);
    const count = getState().post.list.count > 0 ? getState().post.list.count - 1 : 0;
    const newList = {
      count,
      rows: postList
    };

    const res = await api
      .del(`${SERVER_ADDR}post/${postId}`);

    if (res.body) {
      dispatch({
        type: POST_LIST,
        result: newList
      });
    }

    dispatch(resetMessage(MESSAGE));
  } catch (e) {
    console.log(e);
  }
}

export const getPostComments = (postId, page = 0, offset = 10) => async (dispatch, getState, api) => {
  try {
    const res = await api
    .get(`${SERVER_ADDR}post/${postId}/comments?page=${page}&offset=${offset}`);
    dispatch({
      type: POST_COMMENTS,
      result: res.body
    });
  } catch (e) {
    console.log(e);
  }
}

export const getPostLikes = (postId, page, offset) => async (dispatch, getState, api) => {
  try {
    const res = await api
    .get(`${SERVER_ADDR}post/${postId}/likes?page=${page}&offset=${offset}`);
    dispatch({
      type: POST_LIKES,
      result: res.body
    });
  } catch (e) {
    console.log(e);
  }
}

export const deleteComment = (postId, commentId) => async (dispatch, getState, api) => {
  try {
    const res = await api
    .del(`${SERVER_ADDR}post/${postId}/comments/${commentId}`);

    dispatch(getPostComments(postId));
  } catch (e) {
    console.log(e);
  }
}